var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page" }, [
    _c("div", { staticClass: "flex-align-center" }, [
      _c(
        "div",
        {
          staticClass: "card",
          staticStyle: { width: "290px", "margin-right": "20px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "flex-between",
              staticStyle: { "margin-bottom": "10px" },
            },
            [
              _c("span", { staticClass: "title-2" }, [
                _vm._v("共" + _vm._s(_vm.baseArr.length) + "个测评"),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "ques-list" },
            _vm._l(_vm.quesList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: {
                    "ques-item": true,
                    "ques-active": index == _vm.topicActiveKey,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-ellipsis-1",
                      staticStyle: { width: "230px" },
                    },
                    [_vm._v(_vm._s(item.title))]
                  ),
                  index < _vm.topicActiveKey
                    ? _c("a-icon", {
                        style: { fontSize: "25px", color: "#1783e8" },
                        attrs: { type: "check-circle" },
                      })
                    : _c("div", { staticClass: "no-check" }),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "card", staticStyle: { flex: "1" } },
        [
          _vm.showComStatus
            ? _c("EvalPreview", {
                ref: "evalPreview",
                attrs: {
                  showHeader: false,
                  activeKey: _vm.topicActiveKey,
                  topicObj: _vm.topicObj,
                  remindStatus: _vm.showRemindStatus,
                  radioDisabled: false,
                  previewEvalData: _vm.currEval,
                },
                on: {
                  changeRadioGroup: _vm.changeRadioGroup,
                  topicStatusChange: _vm.onTopicStatusChange,
                },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "submit-wrap" },
            [
              _vm.canSubmit
                ? [
                    _c(
                      "a-button",
                      {
                        staticClass: "submit",
                        attrs: {
                          loading: _vm.btnLoading,
                          type: "primary",
                          size: "large",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.submitEvaluate.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v("\n            提交测评\n            "),
                        _vm.quesList.length > 1
                          ? _c("span", [
                              _vm._v(
                                "（" + _vm._s(_vm.topicActiveKey + 1) + "）"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                : _c("div", { staticClass: "submit-tip" }, [
                    _vm._v(_vm._s(_vm.topicTip)),
                  ]),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }